import { Page, usePage } from "@tree-company/tree-query";
import { LanguageContext, SurveyContext } from "../app";
import { useContext, MouseEvent } from "react";
import { Header } from "./header";
import translate from "../locales";
import Markdown from "react-markdown";

export default function ErrorPage({ page }: { page: Page }) {
  const language = useContext(LanguageContext);
  const survey = useContext(SurveyContext);
  const { title } = usePage(page);

  function restart(event: MouseEvent) {
    event.preventDefault();

    // Reset the survey
    survey.currentPageIndex = 0;
    survey.notify();
  }

  return (
    <div className="page page--with-logo page--error">
      <Header page={page} />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="81"
        height="81"
        viewBox="0 0 81 81"
        fill="none"
      >
        <mask
          id="mask0_845_4075"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="81"
          height="81"
        >
          <rect
            x="0.451172"
            y="0.786133"
            width="80"
            height="80"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_845_4075)">
          <path
            d="M40.4505 57.4526C41.395 57.4526 42.1866 57.1332 42.8255 56.4943C43.4644 55.8554 43.7839 55.0637 43.7839 54.1193C43.7839 53.1749 43.4644 52.3832 42.8255 51.7443C42.1866 51.1054 41.395 50.786 40.4505 50.786C39.5061 50.786 38.7144 51.1054 38.0755 51.7443C37.4366 52.3832 37.1172 53.1749 37.1172 54.1193C37.1172 55.0637 37.4366 55.8554 38.0755 56.4943C38.7144 57.1332 39.5061 57.4526 40.4505 57.4526ZM37.1172 44.1193H43.7839V24.1193H37.1172V44.1193ZM40.4505 74.1193C35.8394 74.1193 31.5061 73.2443 27.4505 71.4943C23.395 69.7443 19.8672 67.3693 16.8672 64.3693C13.8672 61.3693 11.4922 57.8415 9.74219 53.786C7.99219 49.7304 7.11719 45.3971 7.11719 40.786C7.11719 36.1749 7.99219 31.8415 9.74219 27.786C11.4922 23.7304 13.8672 20.2026 16.8672 17.2026C19.8672 14.2026 23.395 11.8276 27.4505 10.0776C31.5061 8.32764 35.8394 7.45264 40.4505 7.45264C45.0616 7.45264 49.395 8.32764 53.4505 10.0776C57.5061 11.8276 61.0339 14.2026 64.0339 17.2026C67.0339 20.2026 69.4089 23.7304 71.1589 27.786C72.9089 31.8415 73.7839 36.1749 73.7839 40.786C73.7839 45.3971 72.9089 49.7304 71.1589 53.786C69.4089 57.8415 67.0339 61.3693 64.0339 64.3693C61.0339 67.3693 57.5061 69.7443 53.4505 71.4943C49.395 73.2443 45.0616 74.1193 40.4505 74.1193Z"
            fill="url(#paint0_linear_845_4075)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_845_4075"
            x1="7.11719"
            y1="40.786"
            x2="73.7839"
            y2="40.786"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.4" stopColor="#003142" />
            <stop offset="1" stopColor="#40988E" />
          </linearGradient>
        </defs>
      </svg>
      <h1 className="page__title page__title--small">{title}</h1>
      <p className="page__text">
        {translate("error.description", {}, language)}
      </p>

      <div className="page__actions">
        <button className="button button--accent page__next" onClick={restart}>
          {translate("error.restart_survey", {}, language)}
        </button>
      </div>
      <div className="page__disclaimer">
        <Markdown
          components={{
            a({ children, ...props }) {
              // eslint-disable-next-line react/prop-types
              const url = new URL(props.href ?? "", location.href);
              if (url.origin !== location.origin) {
                props.target = "_blank";
                props.rel = "noopener noreferrer";
              }

              return <a {...props}>{children}</a>;
            },
          }}
        >
          {translate("error.methodology", {}, language)}
        </Markdown>
      </div>
    </div>
  );
}
